"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TeamsIntegrationModalMetadataStep = require("./TeamsIntegrationModalMetadataStep");
Object.keys(_TeamsIntegrationModalMetadataStep).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TeamsIntegrationModalMetadataStep[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TeamsIntegrationModalMetadataStep[key];
    }
  });
});